import { IFormattedSystemsForPostRequest } from '../../domain/downloads.types'
import { useDownloadsApi } from '../../infrastructure/api/useDownloadsApi'

export const useDownloadsUseCase = () => {
  const { exportPowerPlantSystemsData, getPowerPlantSystems } = useDownloadsApi()
  return {
    getPowerPlantSystems: async (powerPlantId: number) => {
      return getPowerPlantSystems(powerPlantId)
    },
    exportPowerPlantSystemsData: async (
      powerPlantId: number,
      startDate: string,
      endDate: string,
      systems: IFormattedSystemsForPostRequest
    ) => {
      return exportPowerPlantSystemsData(powerPlantId, startDate, endDate, systems)
    },
  }
}
